import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class NoCacheHeadersInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authReq = req.clone({
      setHeaders: {
        'Cache-Control': 'no-store, no-cache, must-revalidate, private, max-age=0, post-check=0, pre-check=0',
        Pragma: 'no-chance',
        Expires: '0',
        'Clear-Site-Data': '"cache"',
        'X-Content-Type-Options': 'nosniff',
        ETag: '',
        'Last-Modified': '0',
      },
    });

    return next.handle(authReq);
  }
}
